import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const LadySecond = (props: Icon): React.ReactElement =>
  props.variant === "line" ? (
    <svg
      style={{ ...style(props.size, props.height), ...props.style }}
      className={props.className}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 24 24"
    >
      <defs>
        <path
          id="lady-second-line-a"
          d="M16.174 14.33c1.43.386 2.425 1.77 2.49 3.04l.003.13v1.833a.667.667 0 01-1.33.078l-.004-.078V17.5c0-.57-.392-1.262-.983-1.646l-1.074 2.417a.667.667 0 01-.523.39l-.086.006H9.333a.667.667 0 01-.568-.32l-.04-.076-1.075-2.417c-.556.362-.937.997-.98 1.546l-.003.1v1.833a.667.667 0 01-1.33.078l-.004-.078V17.5c0-1.303 1.013-2.77 2.493-3.17a.667.667 0 01.818.47l.002.014 1.12 2.52h4.467l1.12-2.523a.667.667 0 01.82-.48zm-1.672-4.199a.667.667 0 01-.063.94A3.692 3.692 0 0112 12a3.692 3.692 0 01-2.439-.928.667.667 0 11.878-1.004c.44.385.985.599 1.561.599a2.36 2.36 0 001.561-.599.667.667 0 01.94.063zM12 4c.194 0 .388.017.591.048 1.645.228 3.013 1.379 3.5 2.918l.047.161 1.158 3.32a.667.667 0 01-1.229.511l-.03-.072-1.172-3.364A2.968 2.968 0 0012.4 5.367a2.663 2.663 0 00-.4-.034c-.121 0-.25.012-.408.035a2.98 2.98 0 00-2.429 2.057l-.042.141-1.158 3.32a.667.667 0 01-1.28-.364l.02-.075 1.145-3.276a4.296 4.296 0 013.553-3.122C11.612 4.017 11.806 4 12 4z"
        ></path>
      </defs>
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g>
          <mask id="lady-second-line-b" fill="#fff">
            <use xlinkHref="#lady-second-line-a"></use>
          </mask>
          <use
            fill="#FFF"
            fillRule="nonzero"
            xlinkHref="#lady-second-line-a"
          ></use>
          <g
            fill={props.color || theme.palette.grey600}
            mask="url(#lady-second-line-b)"
          >
            <g>
              <path d="M0 0H24V24H0z"></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ) : (
    <svg
      style={{ ...style(props.size, props.height), ...props.style }}
      className={props.className}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <title>{"B4F35AEF-5189-475E-BD05-F3B2C2ADE32C@1x"}</title>
      <defs>
        <path
          d="M12 12c.815 0 1.573-.246 2.207-.667h3.126L16.21 7.216a4.357 4.357 0 00-3.611-3.166A3.942 3.942 0 0012 4c-.204 0-.403.02-.599.05A4.356 4.356 0 007.79 7.216l-1.123 4.117h3.126c.634.421 1.392.667 2.207.667zm-6.667 5.658V20h2v-5.425c-1.232.785-2 1.876-2 3.083zm11.334-3.083V20h2v-2.342c0-1.207-.768-2.298-2-3.083zm-8-.656v3.414h6.666V13.92A9.498 9.498 0 0012 13.333a9.498 9.498 0 00-3.333.586zM10 15.333A.667.667 0 1110 14a.667.667 0 010 1.333zM14 14a.667.667 0 110 1.334A.667.667 0 0114 14zm-1.333 1.333a.667.667 0 11-1.334 0 .667.667 0 011.334 0z"
          id="lady-second-solid-a"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="lady-second-solid-b" fill="#fff">
          <use xlinkHref="#lady-second-solid-a" />
        </mask>
        <use fill="#FFF" fillRule="nonzero" xlinkHref="#lady-second-solid-a" />
        <g
          mask="url(#lady-second-solid-b)"
          fill={props.color || theme.palette.grey600}
        >
          <path d="M0 0h24v24H0z" />
        </g>
      </g>
    </svg>
  );
